const section_title = "section_title";
const entries = "entries"
const entry_title = "entry_title";
const entry_body = "entry_body";

export {
  section_title, entries, entry_title, entry_body
}



// WEBPACK FOOTER //
// ./src/about/data/keys.js